import { gql } from "@apollo/client";
import { DspType } from "../types/DspType";

export const GET_DSP_FOR_DSP_MANAGER = gql`
    query GetDspForDspManager {
        dsp: getDspForDspManager {
            id
            name
            dspCode
        }
    }
`;

export interface GetDspForDspManagerResponse {
    dsp: DspType;
}